import React from 'react';
import t from 'react-translate';
import { NvModal, ModalType } from 'shared/components/nv-modal';
import { useSelector } from 'react-redux';
import { Global, css } from '@emotion/react';
import { gray7 } from 'styles/global_defaults/colors';
import { CourseAliases } from 'redux/schemas/models/course';
import { RootState } from 'redux/schemas';
import { getCourseAliases } from 'redux/selectors/course';
import CollectionListModalBody,
{ CollectionListModalType,
  ModalActionType,
} from './collection-list-modal-body';

export type AddToCollectionModalProps = {
  show: boolean,
  onClose: (isConverted?: boolean) => void
  lessonId: number,
};

const styles = css`
  .overflow-clip {
    overflow: clip !important;
  }
`;

const AddToCollectionModal = (props: AddToCollectionModalProps) => {
  const { show, onClose, lessonId } = props;
  const aliases: CourseAliases = useSelector((state: RootState) => getCourseAliases(state));

  return (
    <React.Fragment>
      <Global
        styles={styles}
      />
      <NvModal
        show={show}
        width={800}
        onClose={() => onClose()}
        type={ModalType.DYNAMIC}
        header={t.TIMELINE.LESSON_OPTIONS.ADD_TO_COLLECTION()}
        bodyClassName='p-0 overflow-clip'
        fullHeight={false}
        headerBgColor={gray7}
        body={(
          <CollectionListModalBody
            lessonId={lessonId}
            onClose={onClose}
            bodyDescription={t.TIMELINE.ADD_TO_COLLECTION_MODAL.DESCRIPTION(aliases.lectureAliases)}
            collectionListModalType={CollectionListModalType.LESSON_LINK}
            modalActionType={ModalActionType.LINK}
          />
        )}
      />
    </React.Fragment>
  );
};

export default AddToCollectionModal;
